import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { LOGO_URL } from "@/lib/landingData";

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth" });
};

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const links = [
    { label: "How it works", id: "how" },
    { label: "AI Academy", id: "ai-academy" },
    { label: "Editions", id: "editions" },
  ];

  return (
    <header
      data-testid="navbar"
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled
          ? "border-b border-white/10 bg-black/70 backdrop-blur-xl"
          : "border-b border-transparent bg-transparent"
      }`}
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4 lg:px-8">
        <button
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          data-testid="navbar-logo"
          className="flex items-center"
          aria-label="b-come home"
        >
          <img src={LOGO_URL} alt="b→come" className="h-14 w-auto sm:h-16" />
        </button>

        <nav className="hidden items-center gap-9 md:flex">
          {links.map((l) => (
            <button
              key={l.id}
              onClick={() => scrollTo(l.id)}
              data-testid={`nav-${l.id}`}
              className="text-sm font-medium text-muted-foreground transition-colors hover:text-foreground"
            >
              {l.label}
            </button>
          ))}
          <button onClick={() => navigate("/pricing")} data-testid="nav-pricing"
            className="text-sm font-medium text-muted-foreground transition-colors hover:text-foreground">
            Pricing
          </button>
        </nav>

        <div className="flex items-center gap-3">
          <button
            onClick={() => scrollTo("start")}
            data-testid="navbar-notify-btn"
            className="inline-flex items-center rounded-full bg-gradient-brand px-5 py-2.5 text-sm font-bold uppercase tracking-wide text-black transition-all hover:scale-105"
          >
            Tell me when it launches
          </button>
        </div>
      </div>
    </header>
  );
};

export default Navbar;
